import React, { useMemo } from 'react';
import GenericDropdown from '@shared/components/GenericDropdown';

const FavMessageSelect = ({ favMessage, handleFavMessage, fav_messages }) => {
  const defaultOption = {
    id: 0,
    fragments: [{ text: 'Sin destacar', bold: false }],
  };
  const options = [
    defaultOption,
    ...(fav_messages?.map(m => ({
      id: m.id,
      fragments: [{ text: m.message || m.description || '', bold: false }],
    })) || []),
  ];

  const selectedItem = useMemo(
    () => options.find(o => o.id === favMessage) || defaultOption,
    [options, favMessage]
  );

  return (
    <GenericDropdown
      items={options}
      selectedItem={selectedItem}
      onSelect={item => handleFavMessage(item?.id ?? 0)}
      buttonLabel="Mensaje a destacar (opcional)"
      heightAuto={true}
      isPrimaryBorder={true}
    />
  );
};

export default FavMessageSelect;
